module.exports = __webpack_public_path__ + "mf-2.8b52445.png";